import moment from "moment"
export const formatBirthday = (value) => {
    if(!value || value === '') return ''
    else {
      if(typeof(value) === 'string') return moment.utc(new Date(value)).format('DD/MM/YYYY')
      if(typeof(value) === 'object') return moment.utc(value.toDate()).format('DD/MM/YYYY')
    }
}